import _compact from 'lodash/compact';
import _find from 'lodash/find';
import _includes from 'lodash/includes';
import _isNumber from 'lodash/isNumber';
import _map from 'lodash/map';
import _sortBy from 'lodash/sortBy';
export function getSelectedModifiers(modifierIds, allModifiers, allSelectedModifiers) {
  return _sortBy(_map(modifierIds, function (modifierId) {
    return {
      modifier: _find(allModifiers, {
        _id: modifierId
      }),
      selected: _includes(allSelectedModifiers, modifierId)
    };
  }), ['order']);
}
export function getFormErrorMessage(modifiers, min, max, modifierSetName) {
  var selectedModifiers = _compact(_map(modifiers, 'selected'));
  var length = selectedModifiers.length;
  if (_isNumber(max) && length > max) {
    return "Select no more than ".concat(max, " modifier").concat(max === 1 ? '' : 's', " in ").concat(modifierSetName, ".");
  }
  if (_isNumber(min) && length < min) {
    return "Select at least ".concat(min, " modifier").concat(min === 1 ? '' : 's', " in ").concat(modifierSetName, ".");
  }
  return '';
}
export function getToggleIconHelpText(isExpanded) {
  if (isExpanded) {
    return 'Collapse modifier set.';
  }
  return 'Expand modifier set.';
}
export function shouldDisableModifierCheckbox(modifiers, isSelected, maxAllowed) {
  var selectedModifiers = _compact(_map(modifiers, 'selected'));
  var shouldDisableUncheckedBoxes = _isNumber(maxAllowed) && selectedModifiers.length >= maxAllowed;
  return shouldDisableUncheckedBoxes && !isSelected;
}